export default {
  "bbt.header.title": "",
  "bbt.header.linkj": "",
  "bbt.header.cic": "",
  "bbt.header.mri": "",
  "bbt.header.menu": "",
} as const;
